import { FieldType } from '@ngx-formly/material';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { debounceTime, switchMap, filter, takeUntil } from 'rxjs/operators';

import { Component, OnInit, OnDestroy } from '@angular/core';

import { ISnAutocompleteFormFieldConfig } from '../../interfaces/autocomplete-form-field-config.interface';

@Component({
  selector: 'sn-autocomplete',
  templateUrl: './autocomplete.form-field.html',
  styleUrls: ['./autocomplete.form-field.scss'],
})
export class SnAutocompleteFormField extends FieldType implements OnInit, OnDestroy {
  public defaultOptions: ISnAutocompleteFormFieldConfig = {
    type: 'autocomplete',
    templateOptions: {
      appearance: 'fill',
    },
  };

  private readonly _results$ = new BehaviorSubject([]);
  private readonly _destroy$ = new Subject<void>();

  constructor() {
    super();
  }

  get results$(): Observable<any[]> {
    return this._results$.asObservable();
  }

  public ngOnInit(): void {
    if (!this.to.fetchFn) {
      return;
    }

    this.formControl.valueChanges
      .pipe(
        debounceTime(300),
        switchMap((value) => this.to.fetchFn(value)),
        takeUntil(this._destroy$),
      )
      .subscribe((value: any) => this._results$.next(value));

    if (this.to.availableOptions && this.to.availableOptions.subscribe) {
      this.to.availableOptions.pipe(takeUntil(this._destroy$)).subscribe((data: any[]) => {
        if (data) {
          this._results$.next(data);
          this.formControl.updateValueAndValidity({ emitEvent: true });
        }
      });
    }
  }

  public ngOnDestroy(): void {
    this._results$.complete();

    this._destroy$.next();
    this._destroy$.complete();
  }

  public trackOption(index: number, item: { label: string; value: any }): any {
    return item.value;
  }

  public onOptionSelected(index: number): void {
    if (this.to.change) {
      const option = this._results$.value[index];

      this.to.change(this.field, option);
    }
  }
}
